@file:OptIn(InternalResourceApi::class)

package tikthrow.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/tikthrow.composeapp.generated.resources/"

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_271_990_178)
internal val Res.drawable.ic_discord: DrawableResource by lazy {
      DrawableResource("drawable:ic_discord", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_discord.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-130_603_703)
internal val Res.drawable.ic_facebook: DrawableResource by lazy {
      DrawableResource("drawable:ic_facebook", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_facebook.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_259_970_037)
internal val Res.drawable.ic_instagram: DrawableResource by lazy {
      DrawableResource("drawable:ic_instagram", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_instagram.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_198_523_888)
internal val Res.drawable.ic_tiktok: DrawableResource by lazy {
      DrawableResource("drawable:ic_tiktok", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_tiktok.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(902_915_167)
internal val Res.drawable.ic_twitter: DrawableResource by lazy {
      DrawableResource("drawable:ic_twitter", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_twitter.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(522_908_175)
internal val Res.drawable.ic_youtube: DrawableResource by lazy {
      DrawableResource("drawable:ic_youtube", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_youtube.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("ic_discord", Res.drawable.ic_discord)
  map.put("ic_facebook", Res.drawable.ic_facebook)
  map.put("ic_instagram", Res.drawable.ic_instagram)
  map.put("ic_tiktok", Res.drawable.ic_tiktok)
  map.put("ic_twitter", Res.drawable.ic_twitter)
  map.put("ic_youtube", Res.drawable.ic_youtube)
}
